import { render, staticRenderFns } from "./FacilityDashboard.vue?vue&type=template&id=18d35f06"
import script from "./FacilityDashboard.vue?vue&type=script&lang=js"
export * from "./FacilityDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports